import { useGetTaskCommentsQuery } from '@exam-management/graphql';
import { createContext, useMemo } from 'react';

import type { QSetCommentContextData } from '../../types';

import type { QSetCommentProviderProps } from './types';

export const QSetCommentContext = createContext<QSetCommentContextData>({
  comments: {
    data: [],
    loading: false,
    error: null,
  },
});

export default function QSetCommentProvider(props: Readonly<QSetCommentProviderProps>) {
  const { children, taskId } = props;

  const {
    data,
    loading: isLoading,
    error,
  } = useGetTaskCommentsQuery({
    variables: {
      getTaskCommentsInputType: {
        taskId,
      },
    },
  });

  const contextValue = useMemo(
    () => ({
      comments: {
        data: data?.wflGetTaskComments.comments ?? [],
        loading: isLoading,
        error: error ?? null,
      },
    }),
    [data],
  );

  return <QSetCommentContext.Provider value={contextValue}>{children}</QSetCommentContext.Provider>;
}
